/** 参考施工排程的连续色带：一项施工在一周内只绘制一个连续区段，而不是每天重复卡片。
 * 按项目工作日切断休息日，跨周/跨月在可见边界续接；只计算位置，不改变业务日期与任务。
 */
import { taskOnDay, shiftDay } from './scheduleCalendar';

/** dates 是连续的七天，tasks/events 是已鉴权摘要。返回互不遮挡的行和起止列。
 * 同日起工优先放长任务，再按稳定 ID 排序，刷新接口顺序不会让色带随机上下跳。
 */
export function scheduleLanes(dates, tasks, events) {
  const segments = [];
  tasks.forEach(task => {
    let start = null;
    dates.forEach((date, column) => {
      const active = taskOnDay(task, date);
      if (active && start === null) start = column;
      if (start !== null && (!active || column === dates.length - 1)) {
        const end = active ? column : column - 1;
        segments.push({ key: `task:${task.id}:${dates[start]}`, kind: 'task', item: task, start, end,
          before: taskOnDay(task, shiftDay(dates[start], -1)), after: taskOnDay(task, shiftDay(dates[end], 1)) });
        start = null;
      }
    });
  });
  events.forEach(event => {
    const start = dates.indexOf(event.date);
    if (start >= 0) segments.push({ key: `event:${event.id}:${event.date}`, kind: event.type === 'city_inspection' ? 'inspection' : 'milestone', item: event, start, end: start });
  });
  segments.sort((a, b) => a.start - b.start || (b.end - b.start) - (a.end - a.start) || a.key.localeCompare(b.key));
  const occupied = [];
  segments.forEach(segment => {
    let lane = occupied.findIndex(end => end < segment.start);
    if (lane < 0) lane = occupied.length;
    occupied[lane] = segment.end;
    segment.lane = lane;
  });
  return { segments, count: occupied.length };
}
